<!-- =========================================================================================
    File Name: Login.vue
    Description: Login Page
    ----------------------------------------------------------------------------------------
    Item Name: Vuesax Admin - VueJS Dashboard Admin Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div id="invoice-page">
    <div
      v-if="boleto.length === 0 && boletoBemProtege.length === 0"
      class="alert alert-danger text-center"
    >
      Nenhum boleto encontrado
    </div>

    <div
      v-else
      :class="`${insideApp == true ? 'bg-white p-2' : 'quebraPagina'}`"
    >
      <boleto2 v-if="isBemProtege" :dadosBoleto="boleto[0]"></boleto2>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import service from './../../services';
import moment from 'moment';
import vSelect from 'vue-select';
import locale from './../../locale';
import VueJsonPretty from 'vue-json-pretty';
import 'vue-json-pretty/lib/styles.css';
import jwt from 'jsonwebtoken';
import functions from '../../utils/functions.js';

import boleto from './../Includes/boleto.vue';
import boleto2 from './../Includes/boleto2.vue';

export default {
  data() {
    return {
      carregando: true,
      boleto: [],
      boletoBemProtege: [],
      logo: 'https://bboneapp.s3.amazonaws.com/evo-gerencial-color.png',
      totalImagensCarregadas: 0,
      insideApp: this.$route.query.insideApp,
      idEmpresa: null,
      decoded: null,
      isBemProtege: false,
      buscouDados: 0,
    };
  },

  methods: {
    validateState(ref) {
      if (
        this.veeFields[ref] &&
        (this.veeFields[ref].dirty || this.veeFields[ref].validated)
      ) {
        return !this.veeErrors.has(ref);
      }
      return null;
    },
    validateClass(ref) {
      if (
        this.veeFields[ref] &&
        (this.veeFields[ref].dirty || this.veeFields[ref].validated)
      ) {
        return this.veeErrors.has(ref);
      }
      return null;
    },
    retornaStyle(nomeEmpresa) {
      //return "background-color:red";
      return `background-image: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' version='1.1' height='20px' width='120px'><text x='0' y='15' fill='black' font-size='12'>${nomeEmpresa}</text></svg>");`;
    },
    setViewport: function () {
      let changeWindowSize = 375;
      let viewportContent = 'width=device-width,initial-scale=1.0';
      if (window.innerWidth <= changeWindowSize) {
        viewportContent = 'width=1024';
      }
      document
        .querySelector("meta[name='viewport']")
        .setAttribute('content', viewportContent);
    },
    verificaBemProtege() {
      const token = localStorage.getItem('user-token');

      if (!token) {
        this.buscaDadosToImpressao();
        return;
      }

      let decoded = null;
      if (token) {
        decoded = jwt.decode(token);
      }
      const idEmpresa = decoded.id_empresa;
      return functions.verificaEmpresaBemProtege(idEmpresa);
    },
    buscaDadosToImpressao() {
      var objSend = {};
      objSend.idRegistroFinanceiro = this.$route.params.idRegistroFinanceiro;
      objSend.nossoNumero =
        this.$route.query.nn || this.$route.params.nossoNumero;

      this.$vs.loading();
      service
        .post('Boletos', 'buscarDadoToImpressao', objSend)
        .then((res) => {
          this.buscouDados = 1;
          this.isBemProtege = [4, 116, 117, 118, 119].includes(
            res.data[0].id_empresa,
          );

          this.carregando = false;
          this.$vs.loading.close();
          if (res.data.length) {
            this.origem = res.data[0].origem;
            if (res.data[0].origem === 'Galaxpay') {
              this.montaboletoComum(res.data);
            } else {
              this.montaBoletoBemProtege(res.data[0]);
            }
          }
        })
        .catch((e) => {
          this.carregando = false;
          this.$vs.loading.close();
          this.$vs.notify({
            position: 'top-center',
            title: 'Atenção',
            text: 'Erro ao Buscar Boleto',
            color: 'danger',
          });
        });
    },
    montaboletoComum(dados) {
      dados.forEach((element) => {
        const dadosAssociado = JSON.parse(element.dadosAssociado);
        element.dadosAssociado = dadosAssociado[0];

        const dadosEmpresa = JSON.parse(element.dadosEmpresa);
        element.dadosEmpresa = dadosEmpresa[0];

        var dadosGalax = JSON.parse(element.retornoAPI);
        dadosGalax = dadosGalax.Charge ? dadosGalax.Charge : dadosGalax;

        var dadosToBoleto = {
          dadosEmpresa: {
            nome: element.dadosEmpresa.razaoSocial,
            cpfcnpj: element.dadosEmpresa.cnpj,
            endereco: element.dadosEmpresa.endereco,
            numero: element.dadosEmpresa.numero,
            complemento: element.dadosEmpresa.complemento,
            bairro: element.dadosEmpresa.bairro,
            cidade: element.dadosEmpresa.cidade,
            estado: element.dadosEmpresa.estado,
            cep: element.dadosEmpresa.cep,
            logo: element.dadosEmpresa.logo,
          },
          dadosPagador: {
            nome: element.dadosAssociado.nome,
            cpfcnpj: element.dadosAssociado.cpfcnpj,
            endereco: element.dadosAssociado.endereco,
            numero: element.dadosAssociado.numero,
            complemento: element.dadosAssociado.complemento,
            bairro: element.dadosAssociado.bairro,
            cidade: element.dadosAssociado.cidade,
            estado: element.dadosAssociado.estado,
            cep: element.dadosAssociado.cep,
          },
          dadosCobranca: {
            id: element.id,
            descricao: dadosGalax.PaymentMethodBoleto.instructions,
            dataVencimento: dadosGalax.Transactions[0].payday,
            dataEmissao: dadosGalax.Transactions[0].createdAt,
            valor: parseInt(dadosGalax.Transactions[0].value) / 100,
            nossoNumero: dadosGalax.Transactions[0].Boleto.bankNumber,
            instrucao: `Este boleto pode ser pago em qualquer banco, mesmo que vencido, desde que não ultrapasse ${dadosGalax.PaymentMethodBoleto.deadlineDays} dia(s) da data do vencimento
(sujeito a multa e juros)`,
            linhaDigitavel: dadosGalax.Transactions[0].Boleto.bankLine,
            barCode: dadosGalax.Transactions[0].Boleto.barCode,
            banco: dadosGalax.Transactions[0].Boleto.bankEmissor,
            placa: element.placa,
            chassi: element.chassi,
            multa: parseInt(dadosGalax.PaymentMethodBoleto.fine) / 100,
            juros: parseInt(dadosGalax.PaymentMethodBoleto.interest) / 100,
            pix: dadosGalax.Transactions[0].Pix
              ? dadosGalax.Transactions[0].Pix.qrCode
              : null,
            referente: element.referente,
            instrucaoInicial: element.instrucaoInicial,
          },
        };

        element.dadosToBoleto = dadosToBoleto;
        this.boleto.push(element);
      });
    },
    montaBoletoBemProtege(dados) {
      const dadosEmpresa = dados.dadosEmpresa;
      const dadosAssociado = dados.dadosAssociado;
      const dadosCobranca = dados.dadosCobranca;
      const boletoBemProtege = {
        dadosEmpresa: {
          nome: dadosEmpresa.razaoSocial,
          cpfcnpj: dadosEmpresa.cnpj,
          endereco: dadosEmpresa.endereco,
          numero: dadosEmpresa.numero,
          complemento: dadosEmpresa.complemento,
          bairro: dadosEmpresa.bairro,
          cidade: dadosEmpresa.cidade,
          estado: dadosEmpresa.estado,
          cep: dadosEmpresa.cep,
          logo: dadosEmpresa.logo,
        },
        dadosPagador: {
          nome: dadosAssociado.nome,
          cpfcnpj: dadosAssociado.cpfcnpj,
          endereco: dadosAssociado.endereco,
          numero: dadosAssociado.numero,
          complemento: dadosAssociado.complemento,
          bairro: dadosAssociado.bairro,
          cidade: dadosAssociado.cidade,
          estado: dadosAssociado.estado,
          cep: dadosAssociado.cep,
        },
        dadosCobranca: {
          id: dados.id,
          dataVencimento: dados.data_vencimento,
          dataEmissao: dados.data_emissao,
          valor: dados.valor_boleto,
          nossoNumero: dados.id_integracao || dados.nosso_numero,
          instrucao: dadosCobranca.instrucaoCaixa,
          linhaDigitavel: dados.linha_digitavel,
          barCode: dados.codigoBarras,
          banco: {
            nomeBanco: dadosCobranca.shortName,
            logoBanco: dadosCobranca.urlLogo,
            codigoBanco: dadosCobranca.COMPE,
            digitoBanco: '7',
            agencia: dadosCobranca.agencia,
            conta: dadosCobranca.conta,
            carteira: dadosCobranca.numeroCarteira,
          },
          placa: dados.placa,
          chassi: dados.chassi,
          multa: dadosCobranca.percentualMulta,
          juros: dadosCobranca.percentualJurosDiario,
          pix: dados.pix_emv,
          originalLimitDatePayment: dados.originalLimitDatePayment,
          referente: dados.referente,
          instrucaoInicial: dadosCobranca.instrucaoInicial,
        },
      };
      this.boleto.push({ ...dados, dadosToBoleto: boletoBemProtege });
    },
  },
  created() {
    this.verificaBemProtege();
  },
  mounted() {
    this.$validator.localize('ptBr', locale);
    if (!this.buscouDados) {
      this.buscaDadosToImpressao();
    }
    this.setViewport();
  },
  components: {
    boleto,
    boleto2,
  },
};
</script>
<style>
.div1,
.div2,
.div3 {
  height: calc(290mm / 3);
  margin: 5px;
}
table td,
table td * {
  vertical-align: top;
}
@page {
  margin: 0;
}
body {
  margin: 0;
  color: #000 !important;
  font-weight: 700;
}
.sheet {
  margin: 0;
  overflow: hidden;
  position: relative;
  box-sizing: border-box;
  page-break-after: always;
}
.quebraPagina {
  page-break-after: always;
  width: 210mm;
  padding: 5px 10px 5px 15px;
}

/** Paper sizes **/
.A3 .sheet {
  width: 297mm;
  height: 419mm;
}
.A3.landscape .sheet {
  width: 420mm;
  height: 296mm;
}
.A4 .sheet {
  width: 210mm;
  height: 296mm;
}
.A4.landscape .sheet {
  width: 297mm;
  height: 209mm;
}
.A5 .sheet {
  width: 148mm;
  height: 209mm;
}
.A5.landscape .sheet {
  width: 210mm;
  height: 147mm;
}

/** Padding area **/
.sheet.padding-10mm {
  padding: 10mm;
}
.sheet.padding-15mm {
  padding: 15mm;
}
.sheet.padding-20mm {
  padding: 20mm;
}
.sheet.padding-25mm {
  padding: 25mm;
}

/** For screen preview **/
@media screen {
  body {
    background: #e0e0e0;
  }
  .sheet,
  .quebraPagina {
    background: white;
    box-shadow: 0 0.5mm 2mm rgba(0, 0, 0, 0.3);
    margin: 5mm;
  }
}

/** Fix for Chrome issue #273306 **/
@media print {
  .A3.landscape {
    width: 420mm;
  }
  .A3,
  .A4.landscape {
    width: 297mm;
  }
  .A4,
  .A5.landscape {
    width: 210mm;
  }
  .A5 {
    width: 148mm;
  }
}
</style>
<style lang="scss">
.wrapper {
  width: 100%;
  min-height: 250px;
  position: relative;
  padding: 15px;
  color: rgba(black, 0.5);
  font-size: small;
  display: inline-block;
  height: calc(290mm / 3);
  .invertida {
    transform: rotate(-180deg);
    -webkit-transform: rotate(-180deg);
    -moz-transform: rotate(-180deg);
    -ms-transform: rotate(-180deg);
    -o-transform: rotate(-180deg);
  }
  .content {
    //margin-top: 60px;
    margin-right: 100px;
    .box {
      padding: 20px;
      border: 1px solid black;
      width: 80%;
      color: black;
    }
  }
  h3 {
    font-size: 1rem;
    text-transform: uppercase;
    position: absolute;
    bottom: 0;
    right: 0;
    margin-right: -100px;
    margin-bottom: 160px;
    transform: rotate(-90deg);
    -webkit-transform: rotate(-90deg);
    -moz-transform: rotate(-90deg);
    -ms-transform: rotate(-90deg);
    -o-transform: rotate(-90deg);
  }
}

.wrapper2 {
  width: 100%;
  min-height: 250px;
  position: relative;
  border-left: 40px solid transparent;
  padding: 15px;
  color: rgba(black, 0.5);
  font-size: small;
  display: inline-block;
  height: calc(290mm / 3);
  .content {
    background-color: #ccc;
    height: 258px;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    .box {
      width: 500px;
      height: 150px;
      background: #fff;
      border: 1px solid black;
      border-radius: 30px;
      padding: 20px;
      color: black;
    }
  }
  .box2 {
    width: 100%;
    background: #fff;
    border: 1px solid black;
    color: black;
  }
  h3 {
    font-size: 1rem;
    text-transform: uppercase;
    position: absolute;
    top: 0;
    left: 0;
    margin-left: -160px;
    margin-top: 160px;
    transform: rotate(90deg);
    -webkit-transform: rotate(90deg);
    -moz-transform: rotate(90deg);
    -ms-transform: rotate(90deg);
    -o-transform: rotate(90deg);
    span {
      font-size: 9px;
      margin-left: 45px;
    }
  }
}
</style>

<style lang="scss">
@media screen {
  .printer {
    display: none;
  }
}
@media print {
  .table-bordered {
    tr:nth-child(2n) {
      background-color: #ffffff !important;
    }
  }
  .non-printer {
    display: none;
  }
  .vue-back-to-top {
    display: none !important;
  }
  .pdf {
    width: auto;
    height: 200mm;
  }
  .folha {
    height: 297mm;
    padding: 0 0 0 0;
    page-break-after: always;
  }
  .btn-print {
    display: none;
  }
  #content-area {
    margin-left: 0px;
  }
  .navbar-sticky .router-view .router-content {
    margin-top: 0px;
  }
  .vs-content-sidebar,
  .router-header,
  .con-pagination-table,
  #data-list-list-view .vs-con-table .vs-table--header,
  .the-footer,
  .vs-navbar {
    display: none !important;
  }
  body,
  .vs-con-table .vs-con-tbody {
    background-color: #ffffff;
  }
  .vx-card,
  #data-list-list-view .vs-con-table .vs-table tr {
    box-shadow: none !important;
  }
  .td-check {
    visibility: hidden;
  }

  .detalheProposta {
    .vs-col {
      width: 100% !important;
    }

    .filtroFotos {
      display: none !important;
    }

    .cardFotos {
      width: 60% !important;
      img {
        height: 100%;
      }
      footer {
        display: none !important;
      }
    }

    h3 {
      button {
        display: none !important;
      }
    }
  }
}
</style>
